import { Link } from 'react-router-dom';

import {
  Button,
  LoadingSpinner,
  StringIndexedObject,
} from '@kanda-libs/ks-design-library';

import { URLS } from 'config';
import FormPage from 'pages/ApplyForFinance/FormPage';

interface SuccessProps {
  job: StringIndexedObject;
  showButton: boolean;
}

const Success = ({ job, showButton }: SuccessProps) => (
  <FormPage showOuterLayout={false} showExampleBanner={false}>
    <div className="flex flex-1 pt-8 pb-12">
      <div className="flex flex-col m-auto">
        <p className="text-20-24-em">Processing Application</p>
        <LoadingSpinner stroke="purple-300" className="mx-auto mt-10" />
        {showButton && (
          <Link
            to={URLS.status.replace(':id?', job.id)}
            className="mx-auto mt-10"
          >
            <Button.Text
              id="apply-submitting-status"
              label="Check status"
              icon="arrow-right"
            />
          </Link>
        )}
      </div>
    </div>
  </FormPage>
);

export default Success;
